<template>
  <v-card class="pa-4 mx-auto" flat>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="px-2">
        <v-select
          outlined
          :items="domains"
          v-model="selectedDomain"
          :loading="Domainloading"
          class="rounded-lg v-input--dense pa-0 ma-0"
          label="دامنه"
          dense
          :rules="[rules.required_domain]"
          hint="لطفا یک دامنه انتخاب کنید"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" class="pa-2" v-if="$vuetify.breakpoint.mdAndUp">
      </v-col>
      <v-col cols="12" md="12" class="px-2">
        <v-alert color="warning" colored-border elevation="2" border="left">
          <v-icon color="warning">mdi-alert</v-icon>
          توجه: اگر یک عنوان وارد کنید همین عنوان با اندیس برای سایر لینکها
          منظور می‌شود. اگر مایل نیستید برای هر لینک عنوان جدا وارد بفرمایید.
        </v-alert>
      </v-col>
      <v-col cols="12" md="4" class="px-2">
        <v-alert color="success" colored-border elevation="2" border="left">
          <a
            @click="downloadFile"
            download="payamakland_shortlink.cvs"
            href="@/assets/file/payamakland_shortlink.cvs"
          >
            <v-icon color="success" right>mdi-download</v-icon>
            دانلود نمونه فایل متنی (CVS)
            <v-icon color="success"> mdi-file-delimited </v-icon>
          </a>
        </v-alert>
      </v-col>
      <v-col cols="12" md="4" class="px-2">
        <v-alert color="success" colored-border elevation="2" border="left">
          <a
            @click="downloadFile"
            download="payamakland_shortlink.txt"
            href="@/assets/file/payamakland_shortlink.txt"
          >
            <v-icon color="success" right>mdi-download</v-icon>
            دانلود نمونه فایل متنی (TXT)
            <v-icon color="success"> mdi-file-document-outline </v-icon>
          </a>
        </v-alert>
      </v-col>
      <v-col cols="12" md="4" class="px-2">
        <v-alert color="success" colored-border elevation="2" border="left">
          <a
            @click="downloadFile"
            download="payamakland_shortlink.xlsx"
            href="@/assets/file/payamakland_shortlink.xlsx"
          >
            <v-icon color="success" right>mdi-download</v-icon>
            دانلود نمونه فایل اکسل (EXCEL)
            <v-icon color="success"> mdi-file-excel </v-icon>
          </a>
        </v-alert>
      </v-col>

      <v-col class="mt-4" cols="12">
        <v-card
          id="uploader"
          ref="uploader"
          class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
          height="200"
          outlined
          @click="dragEvent"
          @dragleave="dragEvent"
          @dragover="dragEvent"
          @drop="dragEvent"
        >
          <v-icon size="68" style="opacity: 0.4"
            >mdi-cloud-upload-outline</v-icon
          >
          <v-card-title class="justify-center">آپلود فایل</v-card-title>
          <v-card-text class="text-center pt-0">
            برای آپلود بکشید و رها کنید یا
            <v-btn class="mx-1" color="primary" min-width="75" small>
              اینجا
            </v-btn>
            کلیک کنید
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="mt-3" cols="12">
        <v-card
          v-show="!!filesPreview && !!filesPreview.length"
          :loading="upLoading"
          class="mx-auto pa-2 rounded-lg"
          flat
          outlined
        >
          <div
            v-for="(item, i) in filesPreview"
            :key="i"
            class="pa-1 text-center"
          >
            <v-list-item>
              <v-list-item-avatar
                :color="item.color || 'success'"
                class="white--text"
                size="64"
              >
                <v-icon
                  >mdi-{{
                    !!item.color ? (!!item.status ? "check" : "close") : "check"
                  }}</v-icon
                >
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="cursor: pointer">{{
                  item.name
                }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <div
                  v-if="!upLoading && (!item.status || !item.color)"
                  class="text-left fill-height"
                >
                  <v-btn icon @click="removeFileFromUpload">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-card>
      </v-col>

      <v-col class="px-2 d-none" cols="12" md="6">
        <v-file-input
          ref="fileInput"
          v-model="selectedFile"
          :error-messages="errors.input"
          accept=".csv, .xls, .xlsx, .txt"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          label="بارگذاری فایل"
          outlined
          prepend-icon=""
          variant="underlined"
          @change="handleFileUpload"
        />
      </v-col>

      <v-col v-if="rerender && Titles.length > 0" cols="12" md="12">
        <v-row no-gutters>
          <v-col class="rounded px-2" cols="12">
            <v-card
              class="pa-5"
              color="rgba(193,193,193,0.58)"
              flat
              height="100%"
              width="100%"
            >
              <p>لینک‌های انتخاب شده:</p>
              <v-data-table
                :headers="headers"
                :items="paginatedLinks"
                hide-default-footer
                class="elevation-1"
              >
                <template slot="item.title" slot-scope="props">
                  <span style="white-space: break-spaces">{{
                    props.item.title
                  }}</span>
                </template>

                <template slot="item.link" slot-scope="props">
                  <span style="white-space: break-spaces">{{
                    props.item.link
                  }}</span>
                </template>
              </v-data-table>
              <div class="spacer"></div>
              <v-pagination
                v-model="currentPage"
                :length="maxPage"
              ></v-pagination>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card-actions class="justify-end px-0">
      <v-btn
        :disabled="!selectedFile"
        class="btn-send-sms btn"
        @click="createGroupShortUrl"
        :loading="loading"
        color="success"
        depressed
        >ساخت لینک کوتاه
        <v-icon>mdi-link-plus</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import "@/assets/css/style.shortlink.css";
import {
  removehttp,
  showSnackbar,
  checkUrl,
  isValidUrl,
  readLinksFromXlsxFile,
  readLinksFromCsvFile,
  readLinksFromTextFile,
  validateLink,
  filterCorrectLinks,
  isLinkInText,
  convertTableToCsv,
  IsValidUrl2,
  downloadCvsFile,
} from "@/assets/js/FunctionLink.js";
import {
  GetDomain,
  GetLink,
  GetMultilink,
  DeleteLink,
  AddLink,
  EditLink,
  savetoken,
  AddMultilink,
} from "./axios_shortlink.js";
export default {
  name: "sendFile",

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5,
      domains: [],
      selectedDomain: "t7r.ir",
      headers: [
        { text: "عنوان", value: "title" },
        { text: "لینک", value: "link" },
      ],
      Titles: [],
      date: null,
      errors: {},
      selectedFile: undefined,
      filesPreview: [],
      upLoading: false,
      rerender: true,
      selectedRow: null,
      inputs: [],
      texts: [],
      loading: false,
      Domainloading: false,
      url: false,
      longUrls: [],
      loadurl: false,
      selectedurl: null,
      rules: {
        required_domain: (value) =>
          !!value?.trim() ? true : "لطفا یک دامنه انتخاب کنید",
        required: (value) =>
          !!value?.trim() ? true : "لطفا آدرس اینترنتی را وارد کنید",
        urlFormat: (value) => {
          const pattern = new RegExp(
            "^(https?:\\/\\/|www\\.)?" + // پروتکل‌های مختلف یا www
              "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // localhost یا دامین
              "(\\d{1,3}(\\.\\d{1,3}){3}))" + // آی‌پی‌ها
              "(\\:\\d+)?" + // پورت (اختیاری)
              "(\\/[-a-zA-Z\\d%_.~+]*)*" + // مسیر
              "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // کوئری پارامتر
              "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$", // هشتگ با مسیر اختیاری
            "i"
          );
          return !!value?.trim() && pattern.test(value)
            ? true
            : "لطفا آدرس اینترنتی معتبر وارد کنید";
        },
        max: (value) =>
          !!value && value.length <= 50
            ? true
            : "عنوان بیشتر از 50 حرف نباشد! لطفا عنوان کوتاه‌تری وارد کنید",
      },
    };
  },

  mounted() {},

  computed: {
    isValid() {
      let flag = true;
      flag = flag && this.selectedRow;
      flag = flag && this.selectedFile;
      return !flag;
    },
    dataTable() {
      return this.Titles.map((title, index) => ({
        title: title,
        link: this.longUrls[index] || "",
      }));
    },
    paginatedLinks() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.dataTable.slice(start, end);
    },
    maxPage() {
      return Math.ceil(this.dataTable.length / this.itemsPerPage);
    },
  },

  watch: {
    selectedFile(val) {
      if (!val) {
        this.filesPreview = [];
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.Domainloading = true;
      GetDomain()
        .then((data) => {
          this.domains = data;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("خطا در دریافت دامنه:", error);
        })
        .finally(() => {
          this.Domainloading = false;
        });
    },
    createGroupShortUrl() {
      if (!this.selectedFile) {
        this.$swal({
          title: "هشدار!",
          text: "لطفاً یک فایل برای آپلود انتخاب کنید.",
          icon: "warning",
          timer: 3000,
        });
        return;
      }
      this.rerender - false;
      this.loading = true;
      this.upLoading = true;
      this.createGrouplinks(this.longUrls, this.Titles);
      this.loading = false;
      this.upLoading = false;
    },
    createGrouplinks(urls, titles) {
      this.listNoUrls = [];
      let invalidUrls = urls.filter((url) => !IsValidUrl2(url));
      this.listNoUrls = invalidUrls;
      if (invalidUrls.length > 0) {
        this.dialog = true;
        // show dialog for select now send delete link message
        //message "لینک‌ها معتبر نیست"
        //for choise "delete"
        if (!this.isDeleteMistakeLink) {
          return;
        }
        this.isDeleteMistakeLink = false;
      } else {
        urls = urls.map((url) => checkUrl(url));

        // for (let i = 0; i < urls.length; i++) {
        //   titles.push(`${titles}(${i + 1})`);
        // }
        if (urls.length === 0) {
          this.$swal({
            title: "خطا!",
            text: "فایل معتبر نیست. لطفا مطابق با الگو فایل خود را بسازید",
            icon: "error",
            confirmButtonText: "باشه",
          });
          this.rerender = false;
          this.Titles = [];
          this.longUrls = [];
          this.loading = false;
          this.removeFileFromUpload();
          return;
        }
        AddMultilink({
          links: urls,
          type_id: 1,
          domainId: 1,
          titles: titles,
        })
          .then((x) => {
            this.$router.push("/shortlink");
          })
          .catch((error) => {
            console.error("خطا در ساخت لینک کوتاه:", error);
            this.$swal({
              title: "خطا!",
              text: "مشکلی در ساخت لینک کوتاه پیش آمد. لطفاً دوباره تلاش کنید.",
              icon: "error",
              confirmButtonText: "باشه",
            });
          });
      }
    },
    downloadFile() {
      this.$swal({
        title: "دانلود موفق!",
        text: "فایل با موفقیت دانلود شد.",
        icon: "success",
        timer: 3000,
      });
    },
    handleFileUpload(event) {
      this.rerender = false;
      this.Titles = [];
      this.longUrls = [];
      if (this.filesPreview === undefined) return;
      this.filesPreview[0] = {
        name: event.name,
        type: event.type,
      };
      this.$swal({
        title: "آپلود موفق!",
        text: "فایل با موفقیت آپلود شد.",
        icon: "success",
        confirmButtonText: "باشه",
      });
      this.$forceUpdate();

      let file = this.filesPreview[0];
      console.log("type", file.type);
      switch (file.type) {
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          readLinksFromXlsxFile(event)
            .then(({ titles, links }) => {
              this.longUrls = links;
              this.Titles = titles;
            })
            .catch((err) => {
              console.log("خطا در دریافت اطلاعات از فایل", err);
            })
            .finally(() => {
              this.$modal.hideLoading();
            });
          break;
        case "text/csv":
          readLinksFromCsvFile(event)
            .then(({ titles, links }) => {
              this.longUrls = links;
              this.Titles = titles;
            })
            .catch((error) => {
              console.error("خطا در خواندن فایل:", error);
            })
            .finally(() => {
              this.$modal.hideLoading();
            });
          break;

        case "text/plain":
          readLinksFromTextFile(event)
            .then(({ titles, links }) => {
              this.longUrls = links;
              this.Titles = titles;
            })
            .catch((error) => {
              console.error("خطا در خواندن فایل:", error);
            })
            .finally(() => {
              this.$modal.hideLoading();
            });
          break;
        default:
          this.$modal.hideLoading();
          window.alert("این نوع فایل پشنیبانی نمی‌شود.");
          break;
      }
      this.rerender = true;
      console.log(this.Titles);
    },
    removeFileFromUpload() {
      this.filesPreview = [];
      this.selectedFile = null;
      this.rerender = false;
      this.Titles = [];
      this.longUrls = [];
    },
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;
      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;

        this.selectedFile = files[0];
        this.handleFileUpload(files[0]);
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
  },
};
</script>

<style>
tr {
  cursor: pointer !important;
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}
</style>
